import React from 'react';
import { Icon } from '../core/Icon.jsx';

export function Field({ label, hint, error, required = false, htmlFor, children, className = '', ...rest }) {
  return (
    <div className={['sp-field', className].filter(Boolean).join(' ')} {...rest}>
      {label && (
        <label className="sp-field__label" htmlFor={htmlFor}>
          {label}{required && <span className="sp-field__req" aria-hidden="true">*</span>}
        </label>
      )}
      {children}
      {error
        ? <span className="sp-field__error"><Icon name="alert-circle" size={12} />{error}</span>
        : hint && <span className="sp-field__hint">{hint}</span>}
    </div>
  );
}
